import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d9c41300"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "policy_detail" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "time" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = {
  key: 0,
  class: "footer_file"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tit_border" }, "附件", -1))
const _hoisted_7 = ["onClick"]

import { ref, onMounted } from "vue"
import router from "@/router"
import { useRoute } from "vue-router"
import { policyDetailApi, informationDetailApi } from "@/api/policy"
import { showNotify, showLoadingToast, closeToast, showConfirmDialog } from "vant"
import commons from "@/utils/commons"

export default /*#__PURE__*/_defineComponent({
  __name: 'policyDetail',
  setup(__props) {

const route = useRoute()
const datas: any = ref({
  title: "",
  publishTime: "",
  content: "",
  attachResource: []
  // file: [{ name: "《基础设施和公用事业特许经营管理办法》.pdf" }, { name: "《基础设施和公用事业特许经营管理办法》.pdf" }]
})
onMounted(() => {
  if (route.query.id) {
    var url =
      route.query.from == "information" ? informationDetailApi : route.query.from == "policy" ? policyDetailApi : ""
    getDetail(route.query.id, url)
  }
})
const getDetail = (id: string, url: any) => {
  showLoadingToast({
    message: "加载中"
  })
  url(id).then((res: any) => {
    if (res.code == 200) {
      datas.value = {}
      closeToast()
      datas.value = res.data
    } else {
      closeToast()
      showNotify({ type: "danger", message: res.message })
    }
  })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, _toDisplayString(datas.value.title), 1),
    _createElementVNode("p", _hoisted_3, _toDisplayString(datas.value.policyFinishTime), 1),
    _createElementVNode("div", {
      class: "content",
      innerHTML: datas.value.content
    }, null, 8, _hoisted_4),
    (datas.value.attachResource?.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _hoisted_6,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(datas.value.attachResource, (item, i) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "file_name",
              key: i + '01',
              onClick: ($event: any) => (_unref(commons).downloadAttachment(item.sfid, item.fileName))
            }, _toDisplayString(item.fileName), 9, _hoisted_7))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})